<template xmlns:background-color="http://www.w3.org/1999/xhtml">
  <a-row :gutter="10">
    <a-col :md="12" :sm="24">
      <a-card :bordered="false">

        <!-- 按钮操作区域 -->
        <a-row style="margin-left: 14px">
          <!--<a-button :disabled="departTree.length!=0" @click="selectStandardDepart" type="primary">查看平台部门</a-button>-->
          <a-button @click="handleAdd(1)" type="primary">{{language['button.add']+language['dashboardVeh.area']}}</a-button>
          <a-button @click="handleAdd(2)" type="primary">{{language['addLowerLevel']}}</a-button>
          <a-button @click="batchDel" type="default">{{language['ipsys.common.batchDelete']}}</a-button>
          <!--<a-button @click="refresh" type="default" icon="reload" :loading="loading">刷新</a-button>-->
        </a-row>
        <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
          <a-alert type="info" :showIcon="true">
            <div slot="message">
              {{language['depart.management.selectedDepart']}}：<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
              <a v-if="this.currSelected.title" style="margin-left: 10px" @click="onClearSelected">{{language['depart.management.cancelSelected']}}</a>
            </div>
          </a-alert>
          <a-input-search @search="onSearch" style="width:100%;margin-top: 10px" :placeholder="language['ad.must']"/>
          <!-- 树-->
          <a-col :md="10" :sm="24" style="max-height: 100vh;overflow-y:scroll;overflow-x: hidden;width: 100%">
            <template>
              <a-dropdown :trigger="[this.dropTrigger]" @visibleChange="dropStatus" style="height: 100px">
                <span style="user-select: none">
                  <a-tree
                    checkable
                    multiple
                    @select="onSelect"
                    @check="onCheck"
                    @rightClick="rightHandle"
                    :selectedKeys="selectedKeys"
                    :checkedKeys="checkedKeys"
                    :treeData="departTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    @expand="onExpand"/>
                </span>
                <!--新增右键点击事件,和增加添加和删除功能-->
                <a-menu slot="overlay">
                  <a-menu-item @click="handleAdd(3)" key="1">{{language['button.add']}}</a-menu-item>
                  <a-menu-item @click="handleAdd(4)" key="2">{{language['common.edit']}}</a-menu-item>
                  <a-menu-item @click="handleDelete" key="3">{{language['common.delete']}}</a-menu-item>
                  <a-menu-item @click="closeDrop" key="4">{{language['common.cancel']}}</a-menu-item>
                  <!--<a-menu-item @click="handleTransferOrg(departTree,selectedKeys)" key="4">迁移组织</a-menu-item>
                  <a-menu-item @click="handleTransferPerson(departTree,selectedKeys)" key="5">迁移人员</a-menu-item>-->
                </a-menu>
              </a-dropdown>
            </template>
          </a-col>
        </div>
      </a-card>
      <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
      <div class="drawer-bootom-button">
        <a-dropdown :trigger="['click']" placement="topCenter">
          <a-menu slot="overlay">
            <!--<a-menu-item key="1" @click="switchCheckStrictly(1)">父子关联</a-menu-item>
            <a-menu-item key="2" @click="switchCheckStrictly(2)">取消关联</a-menu-item>-->
            <a-menu-item key="3" @click="checkALL">{{language['sweep_allcheck']}}</a-menu-item>
            <a-menu-item key="4" @click="cancelCheckALL">{{language['sweep_cancelcheckall']}}</a-menu-item>
            <a-menu-item key="5" @click="expandAll">{{language['sweep_expenseall']}}</a-menu-item>
            <a-menu-item key="6" @click="closeAll">{{language['sweep_collegeall']}}</a-menu-item>
          </a-menu>
          <a-button>
            {{language['sweep_treeoperate']}} <a-icon type="up" />
          </a-button>
        </a-dropdown>
      </div>
      <!---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------>
    </a-col>
    <a-col :md="12" :sm="24">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane :tab="language['Subordinate.list']" key="1">
          <Area-Info ref="areaInfo" @loadTree="loadTree"></Area-Info>
        </a-tab-pane>

      </a-tabs>

    </a-col>
    <cst-bd-area-modal ref="areaModal" @ok="loadData" ></cst-bd-area-modal>
  </a-row>
</template>
<script>
  import AreaInfo from './modules/AreaInfo'
  import CstBdAreaModal from './modules/CstBdAreaModal'
  import {queryAreaTreeList, searchAreaByKeywords, deleteByAreaId} from '@/api/api'
  import {httpAction, deleteAction, getAction} from '@/api/manage'
  import {JeecgListMixin} from '@/mixins/JeecgListMixin'

  export default {
    name: 'DepartList',
    mixins: [JeecgListMixin],
    components: {
      CstBdAreaModal,
      AreaInfo
    },
    data() {
      return {
        allTreeNodes:[],
        artificialPersonList:[{
          id:'',
          applicationName:''
        }],
        siteCodeList:[{
          id:'',
          xxx:''
        }],
        iExpandedKeys: [],
        loading: false,
        autoExpandParent: true,
        currFlowId: '',
        currFlowName: '',
        disable: true,
        treeData: [],
        visible: false,
        departTree: [],
        // standardDepartShow:true,
        rightClickSelectedKey: '',
        rightClickSelectedOrgCode: '',
        hiding: true,
        model: {},
        rightClickSelect:{},
        dropTrigger: '',
        depart: {},
        disableSubmit: false,
        checkedKeys: [],
        selectedKeys: [],
        autoIncr: 1,
        currSelected: {},
        allTreeKeys:[],
        checkStrictly: true,
        labelCol: {
          xs: {span: 24},
          sm: {span: 5}
        },
        wrapperCol: {
          xs: {span: 24},
          sm: {span: 16}
        },
        graphDatasource: {
          nodes: [],
          edges: []
        },
        url: {
          delete: '/sys/area/delete',
          edit: '/sys/area/edit',
          deleteBatch: '/sys/area/deleteBatch',
          exportXlsUrl: "sys/area/exportXls",
          importExcelUrl: "sys/area/importExcel",
        },
        orgCategoryDisabled:false,
      }
    },
    computed: {
      language() {
        return this.$store.getters.language
      },
      importExcelUrl: function () {
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      }
    },
    methods: {
      loadData() {
        this.refresh();
        this.onClearSelected()
      },
      loadTree() {
        var that = this
        that.treeData = []
        that.departTree = []
        queryAreaTreeList({"applicationCode":this.$store.getters.applicationCode,"keyWord":"",}).then((res) => {
          if (res.success) {
            //部门全选后，再添加部门，选中数量增多
            this.allTreeKeys = [];
            for (let i = 0; i < res.result.length; i++) {
              let temp = res.result[i]
              that.treeData.push(temp)
              that.departTree.push(temp)
              that.setThisExpandedKeys(temp)
              that.getAllKeys(temp);
              // console.log(temp.id)
            }

            /*if(that.departTree==[]){
              that.standardDepartShow=true;
            }else{
              that.standardDepartShow=false;
            }*/
            this.loading = false
          }
        })
      },

      setThisExpandedKeys(node) {
        if (node.children && node.children.length > 0) {
          this.iExpandedKeys.push(node.key)
          for (let a = 0; a < node.children.length; a++) {
            this.setThisExpandedKeys(node.children[a])
          }
        }
      },
      refresh() {
        this.loading = true
        this.loadTree()
      },
      // 右键操作方法
      rightHandle(node) {
         this.dropTrigger = 'contextmenu'
         this.rightClickSelectedKey = node.node.eventKey
         this.rightClickSelect = node.node.dataRef
      },
      onExpand(expandedKeys) {
        console.log('onExpand', expandedKeys)
        this.iExpandedKeys = expandedKeys
        this.autoExpandParent = false
      },
      backFlowList() {
        this.$router.back(-1)
      },
      // 右键点击下拉框改变事件
      dropStatus(visible) {
        if (visible == false) {
          this.dropTrigger = ''
        }
      },
      // 右键下拉关闭下拉框
      closeDrop() {
        this.dropTrigger = ''
      },
      addRootNode() {
        this.$refs.nodeModal.add(this.currFlowId, '')
      },
      batchDel: function () {
        console.log(this.checkedKeys)
        if (this.checkedKeys.length <= 0) {
          this.$message.warning(this.language['tip.messageSelectRecord'])
        } else {
          var ids = ''
          for (var a = 0; a < this.checkedKeys.length; a++) {
            ids += this.checkedKeys[a] + ','
          }
          var that = this
          this.$confirm({
            title: this.language['confirm.deletion'],
            content: this.language['sure.delete.selected'] + this.checkedKeys.length + this.language['piece.data.node'],
            onOk: function () {
              deleteAction(that.url.deleteBatch, {ids: ids}).then((res) => {
                if (res.success) {
                  that.$message.success(res.message)
                  that.loadTree()
                  that.onClearSelected()
                } else {
                  that.$message.warning(res.message)
                }
              })
            }
          })
        }
      },
      onSearch(value) {
        let that = this
        if (value) {
          queryAreaTreeList({"applicationCode":this.$store.getters.applicationCode,"keyWord": value}).then((res) => {
            if (res.success) {
              that.departTree = []
              for (let i = 0; i < res.result.length; i++) {
                let temp = res.result[i]
                that.departTree.push(temp)
              }
            } else {
              that.$message.warning(res.message)
            }
          })
        } else {
          that.loadTree()
        }

      },
      nodeModalOk() {
        this.loadTree()
      },
      nodeModalClose() {
      },
      hide() {
        console.log(111)
        this.visible = false
      },
      onCheck(checkedKeys, info) {
        console.log('onCheck', checkedKeys, info)
        this.hiding = false
        //---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------
        if(this.checkStrictly){
          this.checkedKeys = checkedKeys.checked;
        }else{
          this.checkedKeys = checkedKeys
        }
        //---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------
      },
      onSelect(selectedKeys, e) {
        // debugger
        console.log('selected', selectedKeys, e)
        this.hiding = false
        let record = e.node.dataRef
        console.log('onSelect-record', record)
        this.currSelected = Object.assign({}, record)
        this.model = this.currSelected
        this.selectedKeys = [record.key]
        this.model.parentId = record.parentId
        this.$refs.areaInfo.onClearSelected();
        this.$refs.areaInfo.open(record);

      },

      getCurrSelectedTitle() {
        return !this.currSelected.title ? '' : this.currSelected.title
      },
      onClearSelected() {
        this.hiding = true
        this.checkedKeys = []
        this.currSelected = {}
        this.selectedKeys = []
        this.$refs.areaInfo.currentAreaId = ''
        this.$refs.areaInfo.currentArea = {}
        this.$refs.areaInfo.loadData(1);
      },
      handleNodeTypeChange(val) {
        this.currSelected.nodeType = val
      },
      notifyTriggerTypeChange(value) {
        this.currSelected.notifyTriggerType = value
      },
      receiptTriggerTypeChange(value) {
        this.currSelected.receiptTriggerType = value
      },
      emptyCurrForm() {
        this.$refs.form.resetFields();
        this.model={}
      },
      nodeSettingFormSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            console.log('Received values of form: ', this.model)
          }
        })
      },
      openSelect() {
        this.$refs.sysDirectiveModal.show()
      },
      handleAdd(num) {
        if (num == 1) {
          this.$refs.areaModal.add({areaLevel: "0"})
          this.$refs.areaModal.title = this.language['common.insertButton']
        } else if (num == 2) {
          let key = this.currSelected.key

          if (!key) {
            this.$message.warning(this.language['please.click.select.upperFirst'])
            return false
          }

          this.$refs.areaModal.add(this.currSelected)
          this.$refs.areaModal.title = this.language['common.insertButton']
        } else if (num == 3){
          this.$refs.areaModal.add(this.rightClickSelect)
          this.$refs.areaModal.title = this.language['common.insertButton']
        }else {
          console.log('this.currSelected: ', this.rightClickSelect)
          this.$refs.areaModal.edit(this.rightClickSelect)
          this.$refs.areaModal.title = this.language['common.edit']
        }
      },
      handleDelete() {
        var that = this
        this.$confirm({
          title: that.language['confirm.deletion'],
          content: that.language['sure.delete.selected'] + 1 +that.language['piece.data.node'],
          onOk: function () {
            deleteByAreaId({id: that.rightClickSelectedKey}).then((resp) => {
              if (resp.success) {
                //删除成功后，去除已选中中的数据
                that.checkedKeys.splice(that.checkedKeys.findIndex(key => key === that.rightClickSelectedKey), 1);
                that.$message.success(that.language['common.deleteSuccess']+'!')
                that.loadTree()
                //删除后同步清空右侧基本信息内容
                let orgCode=that.model.orgCode;
                if(orgCode && orgCode === that.rightClickSelectedOrgCode){
                  that.onClearSelected()
                }
              } else {
                that.$message.warning(this.language['operationfailed']+'!')
              }
            })
          }
        })
      },
      getAllNodes(node) {
        this.allTreeNodes.push(node);
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            this.getAllNodes(node.children[a])
          }
        }
      },
      selectDirectiveOk(record) {
        this.nodeSettingForm.setFieldsValue({directiveCode: record.directiveCode})
        this.currSelected.sysCode = record.sysCode
      },
      getFlowGraphData(node) {
        this.graphDatasource.nodes.push({
          id: node.id,
          text: node.flowNodeName
        })
        if (node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            let temp = node.children[a]
            this.graphDatasource.edges.push({
              source: node.id,
              target: temp.id
            })
            this.getFlowGraphData(temp)
          }
        }
      },
      //---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------
      expandAll () {
        this.iExpandedKeys = this.allTreeKeys
      },
      closeAll () {
        this.iExpandedKeys = []
      },
      checkALL () {
        this.checkStriccheckStrictlytly = false
        this.checkedKeys = this.allTreeKeys
      },
      cancelCheckALL () {
        //this.checkedKeys = this.defaultCheckedKeys
        this.checkedKeys = []
      },
      switchCheckStrictly (v) {
        if(v==1){
          this.checkStrictly = false
        }else if(v==2){
          this.checkStrictly = true
        }
      },
      getAllKeys(node) {
        // console.log('node',node);
        this.allTreeKeys.push(node.key)
        if (node.children && node.children.length > 0) {
          for (let a = 0; a < node.children.length; a++) {
            this.getAllKeys(node.children[a])
          }
        }
      }
      //---- author:os_chengtgen -- date:20190827 --  for:切换父子勾选模式 =======------

    },
    created() {
      this.currFlowId = this.$route.params.id
      this.currFlowName = this.$route.params.name
      // this.loadTree()
    },

  }
</script>
<style scoped>
  .ant-card-body .table-operator {
    margin: 15px;
  }

  .anty-form-btn {
    width: 100%;
    text-align: center;
  }

  .anty-form-btn button {
    margin: 0 5px;
  }

  .anty-node-layout .ant-layout-header {
    padding-right: 0
  }

  .header {
    padding: 0 8px;
  }

  .header button {
    margin: 0 3px
  }

  .ant-modal-cust-warp {
    height: 100%
  }

  .ant-modal-cust-warp .ant-modal-body {
    height: calc(100% - 110px) !important;
    overflow-y: auto
  }

  .ant-modal-cust-warp .ant-modal-content {
    height: 90% !important;
    overflow-y: hidden
  }

  #app .desktop {
    height: auto !important;
  }

  /** Button按钮间距 */
  .ant-btn {
    margin-left: 3px
  }

  .drawer-bootom-button {
    /*position: absolute;*/
    bottom: 0;
    width: 100%;
    border-top: 1px solid #e8e8e8;
    padding: 10px 16px;
    text-align: left;
    left: 0;
    background: #fff;
    border-radius: 0 0 2px 2px;
  }
</style>